<div class="email-card">

  <!-- Header -->
  <div class="dialog-header">

    <div class="header-left">
      <div class="icon-box">
        <mat-icon>mail_outline</mat-icon>
      </div>

      <div>
        <div class="title" *ngIf="isEmailAssociated==false">Add document email</div>
        <div class="title" *ngIf="isEmailAssociated==true">Update document email</div>
        <div class="subtitle">{{folderName}}</div>
      </div>
    </div>

    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

  </div>

  <div class="divider"></div>

  <!-- Body -->
  <div class="dialog-body">

    <p class="description">
      Documents sent to this email address will be automatically saved to this folder. 
      Add or edit the email name to your preference.
    </p>

    <label class="label">
      FOLDER EMAIL ADDRESS
    </label>

   <div class="input-wrapper">
      <input maxlength="100" type="text" [(ngModel)]="emails" placeholder="add email"
       (keypress)="allowEmailChars($event)"
       (paste)="onPasteEmail($event)"/>

      <span class="domain">@inbound.flowtrics.com</span>

      <button *ngIf="emails"
          mat-icon-button
          class="copy-btn"
          matTooltip="Copy email"
          (click)="copyEmail()">
        <mat-icon>content_copy</mat-icon>
      </button>

      <button *ngIf="isEmailAssociated==true" mat-icon-button class="edit-btn"
        matTooltip="Delete email"  (click)="emailDelete()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

  </div>

  <!-- Footer -->
  <div class="dialog-footer">

    <button mat-stroked-button class="cancel-btn" (click)="close()">
      Cancel
    </button>

    <button mat-flat-button color="primary" class="accept-btn" 
     [disabled]="!emails || !emails.trim()" (click)="acceptEmail()">
      Accept
    </button>

  </div>

</div>